import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocalization } from '~/framework';
import { useApiErrorMessageToast } from './useApiErrorMessageToast';
import { saveGuide } from '../api/guides';
import { getGuidesKey } from '~/pages/_shared/useGuides';
import { getGuideKey } from '~/pages/_shared/useGuide';
import { SaveGuideOptions } from '../api/guides/saveGuide.api';

type Options = {
   onSuccess?: () => any;
   onError?: (errors: any, variables: Partial<SaveGuideOptions>) => any;
};

export function useSaveGuide(guideid: number | null, { onSuccess, ...options }: Options = {}) {
   const { _js } = useLocalization();
   const queryClient = useQueryClient();

   const { handleErrorOrRedirectToLogin } = useApiErrorMessageToast({
      default: _js('There was an error saving the guide, please try again.'),
   });

   return useMutation({
      mutationFn: async ({ revisionid, ...fields }: SaveGuideOptions & { revisionid: number }) => {
         if (!guideid) return;
         return await saveGuide(guideid, revisionid, fields);
      },
      onError: handleErrorOrRedirectToLogin,
      onSuccess: () => {
         onSuccess?.();
         queryClient.invalidateQueries({ queryKey: getGuideKey(guideid) });
         queryClient.invalidateQueries({ queryKey: getGuidesKey() });
      },
      ...options,
   });
}
